<template>
    <DnInput :wrapper-attrs="{ class: 'base-input' }">
        <template
            v-for="name in Object.keys($slots)"
            v-slot:[name]="scope"
        >
            <slot
                :name="name"
                v-bind="scope"
            />
        </template>

        <template #clear>
            <BaseIcon icon="close" />
        </template>
    </DnInput>
</template>

<script setup>
import DnInput from '@digitalnatives/form-input';
</script>

<style lang="less">
.dn-input.base-input {
    .input();
    --label-indent-y: -1.5rem;
    --label-indent-x: 0;
    --label-scale: .625;

    .dn-input__field {
        box-shadow: none;
    }

    &.dn-input--has-floating-label .dn-input__field-body {
        padding: .875rem 0;
    }

    .dn-input__label {
        .typography-text-sm();
        left: 0;
        color: inherit;
        text-transform: uppercase;
    }

    .dn-input__field-aside {
        padding-right: 0;
    }

    &[data-focus='true'] {
        .input--focussed();
    }

    &[data-validation='valid'] {
        .input--valid();
    }

    &[data-validation='invalid'] {
        .input--invalid();
    }

    .dn-input__clear .dn-icon svg {
        height: auto;
    }
}
</style>
